import type { CommunicationMetric, CommunicationStatsResponse } from "@/shared/api/communication-stats"

export type CommunicationMetricKey = "messages" | "p2pCalls" | "groupConferences" | "sipCalls"

export interface MetricPresentation {
    key: CommunicationMetricKey
    title: string
    totalDescription: string
    unit: string
    color: string
}

export const metricPresentations = [
    {
        key: "messages",
        title: "Сообщения",
        totalDescription: "Всего существующих неудалённых пользовательских сообщений",
        unit: "сообщений",
        color: "rgb(37, 99, 235)",
    },
    {
        key: "p2pCalls",
        title: "P2P-звонки",
        totalDescription: "Всего P2P-комнат без SIP-участника",
        unit: "звонков",
        color: "rgb(5, 150, 105)",
    },
    {
        key: "groupConferences",
        title: "Групповые конференции",
        totalDescription: "Всего комнат двух групповых типов",
        unit: "конференций",
        color: "rgb(124, 58, 237)",
    },
    {
        key: "sipCalls",
        title: "SIP-вызовы",
        totalDescription: "Всего инициированных SIP-плеч",
        unit: "вызовов",
        color: "rgb(217, 119, 6)",
    },
] as const satisfies readonly MetricPresentation[]

export const getMetricEntries = (data: CommunicationStatsResponse): readonly {
    presentation: MetricPresentation
    metric: CommunicationMetric
}[] => metricPresentations.map((presentation) => ({
    presentation,
    metric: data[presentation.key],
}))
